/**
 * Texte für Kampagnen, Datensätze und den CSV-Import.
 * Deutsch ist die Referenz für alle anderen Sprachen.
 */
export const deCampaigns = {
  'nav.campaigns': 'Kampagnen',

  'campaigns.title': 'Kampagnen',
  'campaigns.empty': 'Es gibt noch keine Kampagne. Legen Sie Ihre erste an.',
  'campaigns.create': 'Kampagne anlegen',
  'campaigns.name': 'Name',
  'campaigns.description': 'Beschreibung',
  'campaigns.open': 'Öffnen',
  'campaigns.showArchived': 'Archivierte anzeigen',
  'campaigns.state.active': 'Läuft',
  'campaigns.state.stopped': 'Gestoppt',
  'campaigns.state.archived': 'Archiviert',
  'campaigns.mode.pool': 'Gemeinsame Liste',
  'campaigns.mode.assigned': 'Feste Zuteilung',
  'campaigns.contacts': 'Datensätze',

  'campaign.tab.overview': 'Übersicht',
  'campaign.tab.contacts': 'Datensätze',
  'campaign.tab.callers': 'Caller',
  'campaign.tab.statistics': 'Statistik',
  'campaign.tab.recordings': 'Aufnahmen',
  'campaign.tab.settings': 'Einstellungen',
  'campaign.comingSoon': 'Dieser Bereich entsteht in einem der nächsten Schritte.',
  'campaign.start': 'Kampagne starten',
  'campaign.stop': 'Kampagne stoppen',
  'campaign.archive': 'Archivieren',
  'campaign.restore': 'Aus dem Archiv holen',
  'campaign.delete': 'Kampagne löschen',
  'campaign.deleteWarning':
    'Die Kampagne und ihre Datensätze werden aus Ihrer Ansicht entfernt. Dieser Schritt lässt sich nicht rückgängig machen.',
  'campaign.stopFirst': 'Stoppen Sie die Kampagne, bevor Sie diese Einstellung ändern.',

  'campaign.overview.contacts': 'Datensätze',
  'campaign.overview.callers': 'Freigegebene Caller',
  'campaign.overview.mode': 'Arbeitsweise',
  'campaign.overview.state': 'Status',
  'campaign.overview.created': 'Angelegt am',

  'campaign.settings.basics': 'Grunddaten',
  'campaign.settings.mode': 'Arbeitsweise',
  'campaign.settings.modeHint':
    'Gemeinsame Liste: alle Caller arbeiten dieselbe Liste ab. Feste Zuteilung: jeder Caller bekommt eigene Datensätze.',
  'campaign.settings.changeMode': 'Arbeitsweise ändern',
  'campaign.settings.modePreview':
    'Das betrifft {contacts} Datensätze und {callers} Caller. Fortfahren?',
  'campaign.settings.country': 'Land der Telefonnummern',
  'campaign.settings.countryHint':
    'Nummern ohne Ländervorwahl werden mit diesem Land ergänzt.',
  'campaign.settings.advanced': 'Erweiterte Einstellungen',
  'campaign.settings.parallelCalls': 'Gleichzeitige Anwahlen',
  'campaign.settings.parallelMode': 'Zählweise',
  'campaign.settings.parallelMode.per_caller': 'je Caller',
  'campaign.settings.parallelMode.global': 'insgesamt',
  'campaign.settings.parallelWarning':
    'Bei diesem Wert kann es passieren, dass Angerufene kurz in der Warteschleife landen.',
  'campaign.settings.retry': 'Wiederholungsversuche in 24 Stunden',
  'campaign.settings.recording': 'Gespräche aufzeichnen',
  'campaign.settings.mailbox': 'Anrufbeantworter erkennen',
  'campaign.settings.inbound': 'Eingehende Anrufe annehmen',
  'campaign.settings.queue': 'Warteschleife',
  'campaign.settings.queueWait': 'Maximale Wartezeit in Sekunden',
  'campaign.settings.fields': 'Eigene Felder',
  'campaign.settings.fieldsHint':
    'Zusätzliche Angaben zu Ihren Datensätzen. Beim Import angelegte Felder erscheinen hier ebenfalls.',
  'campaign.settings.fieldName': 'Feldname',
  'campaign.settings.addField': 'Feld hinzufügen',
  'campaign.settings.required': 'Vor Gesprächsende ausfüllen',
  'campaign.settings.removeField': 'Feld entfernen',
  'campaign.settings.saved': 'Gespeichert.',

  'campaign.callers.title': 'Freigegebene Caller',
  'campaign.callers.hint': 'Nur freigegebene Caller sehen die Datensätze dieser Kampagne.',
  'campaign.callers.add': 'Caller freigeben',
  'campaign.callers.remove': 'Freigabe entfernen',
  'campaign.callers.empty': 'Für diese Kampagne ist noch niemand freigegeben.',
  'campaign.callers.assignedContacts': 'zugeteilte Datensätze',
  'campaign.callers.removed':
    'Freigabe entfernt. {count} Datensätze sind jetzt keinem Caller zugeteilt.',

  'contacts.title': 'Datensätze',
  'contacts.search': 'Suchen',
  'contacts.searchHint': 'Nummer, Name, Notiz oder Datensatz-Nummer',
  'contacts.empty': 'Es gibt noch keine Datensätze.',
  'contacts.noResults': 'Zu dieser Suche gibt es keine Datensätze.',
  'contacts.create': 'Datensatz erstellen',
  'contacts.import': 'CSV importieren',
  'contacts.export': 'Als CSV herunterladen',
  'contacts.total': '{count} Datensätze',
  'contacts.page': 'Seite {page} von {pages}',
  'contacts.next': 'Weiter',
  'contacts.previous': 'Zurück',
  'contacts.filter.status': 'Status',
  'contacts.filter.all': 'Alle',
  'contacts.filter.assigned': 'Caller',
  'contacts.filter.archived': 'Archiv',
  'contacts.filter.archived.active': 'Aktive',
  'contacts.filter.archived.archived': 'Archivierte',
  'contacts.filter.archived.all': 'Alle',
  'contacts.filter.callbackFrom': 'Rückruf ab',
  'contacts.filter.callbackTo': 'Rückruf bis',

  'contact.id': 'Datensatz-Nummer',
  'contact.phone': 'Telefonnummer',
  'contact.firstName': 'Vorname',
  'contact.lastName': 'Nachname',
  'contact.note': 'Notiz',
  'contact.status': 'Status',
  'contact.callbackDate': 'Rückruf am',
  'contact.assignedTo': 'Zugeteilt an',
  'contact.unassigned': 'Niemandem zugeteilt',
  'contact.archive': 'Archivieren',
  'contact.restore': 'Zurückholen',
  'contact.delete': 'Löschen',
  'contact.deleteWarning': 'Dieser Datensatz wird aus Ihrer Ansicht entfernt.',
  'contact.saved': 'Gespeichert.',
  'contact.archived': 'Archiviert',
  'contact.duplicateHint': 'Diese Nummer gibt es bereits im Datensatz {id}.',
  'contact.requiredBeforeCall': 'Vor Gesprächsende auszufüllen',

  'status.new': 'Neu',
  'status.successful': 'Erfolgreich',
  'status.callback': 'Rückruf',
  'status.not_interested': 'Kein Interesse',

  'import.title': 'CSV importieren',
  'import.step.file': 'Datei auswählen',
  'import.step.mapping': 'Spalten zuordnen',
  'import.step.duplicates': 'Doppelte Einträge',
  'import.step.result': 'Ergebnis',
  'import.chooseFile': 'CSV-Datei auswählen',
  'import.fileHint': 'Nur CSV-Dateien, höchstens 20 MB.',
  'import.preview': 'Vorschau',
  'import.rows': 'Zeilen insgesamt',
  'import.validPhones': 'gültige Telefonnummern',
  'import.invalidPhones': 'ungültige Telefonnummern',
  'import.duplicates': 'doppelte Nummern',
  'import.withId': 'Zeilen mit Datensatz-Nummer',
  'import.mapping.phone': 'Spalte mit der Telefonnummer',
  'import.mapping.firstName': 'Spalte mit dem Vornamen',
  'import.mapping.lastName': 'Spalte mit dem Nachnamen',
  'import.mapping.none': '– nicht übernehmen –',
  'import.mapping.hint':
    'Alle übrigen Spalten werden als eigene Felder der Kampagne übernommen.',
  'import.duplicates.question': 'Was soll mit bereits vorhandenen Nummern passieren?',
  'import.duplicates.skip': 'Vorhandene Datensätze unverändert lassen',
  'import.duplicates.overwrite': 'Vorhandene Datensätze mit den neuen Angaben ergänzen',
  'import.duplicates.overwriteHint':
    'Leere Spalten überschreiben vorhandene Angaben nicht.',
  'import.start': 'Import starten',
  'import.running': 'Der Import läuft …',
  'import.result.created': 'neu angelegt',
  'import.result.updated': 'aktualisiert',
  'import.result.skippedDuplicates': 'übersprungen (bereits vorhanden)',
  'import.result.skippedInvalid': 'übersprungen (fehlerhaft)',
  'import.result.createdFields': 'Neue Felder',
  'import.result.errors': 'Fehlerhafte Zeilen',
  'import.error.invalid_phone': 'Zeile {line}: Telefonnummer nicht verwendbar',
  'import.error.missing_phone': 'Zeile {line}: keine Telefonnummer',
  'import.error.unknown_public_id': 'Zeile {line}: unbekannte Datensatz-Nummer',
  'import.done': 'Fertig',

  'error.campaign.not_found': 'Diese Kampagne wurde nicht gefunden.',
  'error.campaign.name_required': 'Bitte einen Namen für die Kampagne eingeben.',
  'error.campaign.must_be_stopped': 'Stoppen Sie die Kampagne, bevor Sie diese Einstellung ändern.',
  'error.campaign.no_callers_assigned': 'Ordnen Sie der Kampagne zuerst mindestens einen Caller zu.',
  'error.campaign.archived_cannot_activate': 'Eine archivierte Kampagne kann nicht gestartet werden.',
  'error.campaign.not_released': 'Diese Kampagne ist für Sie nicht freigegeben.',
  'error.campaign.member_required': 'Dieser Caller ist für die Kampagne nicht freigegeben.',
  'error.campaign.member_not_found': 'Dieser Zugang ist für die Kampagne nicht freigegeben.',
  'error.campaign.parallel_out_of_range': 'Bitte einen Wert zwischen 1 und 5 wählen.',
  'error.campaign.invalid_country': 'Dieses Land steht nicht zur Verfügung.',
  'error.contact.not_found': 'Dieser Datensatz wurde nicht gefunden.',
  'error.contact.invalid_phone': 'Diese Telefonnummer können wir nicht verwenden. Bitte prüfen Sie die Eingabe.',
  'error.contact.invalid_status': 'Dieser Status steht nicht zur Verfügung.',
  'error.contact.invalid_callback_date': 'Bitte ein gültiges Datum angeben.',
  'error.contact.assignment_admin_only': 'Die Zuordnung kann nur ein Administrator ändern.',
  'error.field.not_found': 'Dieses Feld wurde nicht gefunden.',
  'error.field.name_taken': 'Ein Feld mit diesem Namen gibt es bereits.',
  'error.field.name_required': 'Bitte einen Namen für das Feld eingeben.',
  'error.field.name_reserved': 'Dieser Name ist bereits für eine feste Spalte vergeben. Bitte einen anderen wählen.',
  'error.import.file_required': 'Bitte wählen Sie eine CSV-Datei aus.',
  'error.import.empty_file': 'Die Datei ist leer.',
  'error.import.file_too_large': 'Die Datei ist zu groß. Bitte teilen Sie die Liste in mehrere Dateien auf.',
  'error.import.not_found': 'Die hochgeladene Datei ist nicht mehr vorhanden. Bitte laden Sie sie erneut hoch.',
  'error.import.phone_column_required': 'Bitte wählen Sie die Spalte mit der Telefonnummer.',
} as const;
